var map = {
	"./CUSTOMER.ts": "./app/utils/API/apis/CUSTOMER.ts",
	"./EMAIL.ts": "./app/utils/API/apis/EMAIL.ts",
	"./GUESS.ts": "./app/utils/API/apis/GUESS.ts",
	"./MARSCO.ts": "./app/utils/API/apis/MARSCO.ts",
	"./OAUTH_USER.ts": "./app/utils/API/apis/OAUTH_USER.ts",
	"./PC.ts": "./app/utils/API/apis/PC.ts",
	"./PORTAL.js": "./app/utils/API/apis/PORTAL.js",
	"./STATIC.js": "./app/utils/API/apis/STATIC.js",
	"./TRADE.js": "./app/utils/API/apis/TRADE.js",
	"./UPPLAY.ts": "./app/utils/API/apis/UPPLAY.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/utils/API/apis sync \\.[jt]sx?$";